import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { JSMGracePeriodBanner } from './index.tsx';

const JSMGracePeriodBannerLazy = lazyAfterPaint<typeof JSMGracePeriodBanner>(
	() =>
		import(/* webpackChunkName: "async-jsm-grace-period-banner" */ './index').then(
			(module) => module.JSMGracePeriodBanner,
		),
	{ entryFsSsrOverride: 'exclude', entryFsSsrLiftImportToModule: false },
);

export const JSMGracePeriodBannerAsync = () => {
	return (
		<JSErrorBoundary id="async.jsm-grace-period-banner" teamName="Sequoia" fallback="unmount">
			<Placeholder name="async-jsm-grace-period-banner" fallback={null}>
				<JSMGracePeriodBannerLazy />
			</Placeholder>
		</JSErrorBoundary>
	);
};
